import { __decorate } from "tslib";
import React, { Component } from 'react';
import classNames from 'classnames';
import { action, toJS } from 'mobx';
import isPromise from 'is-promise';
import noop from 'lodash/noop';
import debounce from 'lodash/debounce';
import KeyCode from '../../../lib/_util/KeyCode';
import { math } from 'choerodon-ui/dataset';
import ConfigContext from '../../../lib/config-provider/ConfigContext';
import Table from '../table/Table';
import TableProfessionalBar from '../table/query-bar/TableProfessionalBar';
import { SelectionMode, TableMode, TableQueryBarType } from '../table/enum';
import { DataSetEvents, DataSetSelection } from '../data-set/enum';
import autobind from '../_util/autobind';
import { getColumnKey } from '../table/utils';
import SelectionList, { SelectionsPosition } from './SelectionList';
import { TriggerViewMode } from '../trigger-field/TriggerField';
import Picture from '../picture';
import ObserverNumberField from '../number-field';
export default class LovView extends Component {
    constructor() {
        super(...arguments);
        this.resizedColumns = new Map();
        this.handleSelect = debounce((event) => {
            const { selectionMode } = this;
            const { onBeforeSelect = noop, multiple, dataSet, tableProps, } = this.props;
            let records = selectionMode === SelectionMode.treebox ?
                dataSet.treeSelected : (selectionMode === SelectionMode.rowbox || multiple) ?
                dataSet.selected : dataSet.current ? [dataSet.current] : [];
            // 满足单选模式下，双击和勾选框选中均支持
            if (tableProps && tableProps.alwaysShowRowBox && !event) {
                records = dataSet.selected;
            }
            const record = multiple ? records : records[0];
            const beforeSelect = onBeforeSelect(record);
            if (isPromise(beforeSelect)) {
                return beforeSelect.then(result => {
                    if (result !== false) {
                        this.closeModal(record);
                    }
                });
            }
            if (beforeSelect !== false) {
                this.closeModal(record);
            }
            return false;
        }, 300);
    }
    static get contextType() {
        return ConfigContext;
    }
    componentWillMount() {
        const { dataSet, dataSet: { selection }, multiple, viewMode, } = this.props;
        this.selection = selection;
        dataSet.selection = multiple ? DataSetSelection.multiple : DataSetSelection.single;
        if (viewMode === TriggerViewMode.popup && multiple) {
            dataSet.addEventListener(DataSetEvents.batchSelect, this.handleSelect);
            dataSet.addEventListener(DataSetEvents.batchUnSelect, this.handleSelect);
        }
    }
    componentWillUnmount() {
        const { dataSet, multiple, viewMode } = this.props;
        dataSet.selection = this.selection;
        if (viewMode === TriggerViewMode.popup && multiple) {
            dataSet.removeEventListener(DataSetEvents.batchSelect, this.handleSelect);
            dataSet.removeEventListener(DataSetEvents.batchUnSelect, this.handleSelect);
        }
    }
    shouldComponentUpdate(nextProps) {
        const { viewMode } = this.props;
        if (viewMode === TriggerViewMode.popup && nextProps.popupHidden) {
            return false;
        }
        return true;
    }
    /* istanbul ignore next */
    getColumns() {
        const { config: { lovItems }, tableProps, viewMode, } = this.props;
        return lovItems
            ? lovItems
                .filter(({ gridField }) => gridField === 'Y')
                .sort(({ gridFieldSequence: seq1 }, { gridFieldSequence: seq2 }) => seq1 - seq2)
                .map(({ display, gridFieldName, gridFieldWidth, gridFieldAlign, gridFieldType }) => {
                let column = {};
                if (tableProps && tableProps.columns) {
                    column = tableProps.columns.find(c => c.name === gridFieldName);
                }
                // 渲染 lov 中的 超链接 和 图片类型字段
                column = column || {};
                if (gridFieldType && gridFieldType.toLowerCase() === 'href') {
                    column.renderer = ({ value }) => (value ? (React.createElement("a", { href: value, title: value, target: "_blank", rel: "noopener noreferrer" }, value)) : undefined);
                }
                else if (gridFieldType && gridFieldType.toLowerCase() === 'picture') {
                    column.renderer = ({ value }) => (value ? React.createElement(Picture, { src: value, objectFit: "contain", height: "inherit", block: false }) : undefined);
                }
                else if (gridFieldType && gridFieldType.toLowerCase() === 'percent') {
                    column.renderer = ({ value }) => (value ? `${math.multipliedBy(value, 100)}%` : value);
                }
                return {
                    ...column,
                    key: gridFieldName,
                    header: display,
                    name: gridFieldName,
                    width: viewMode === TriggerViewMode.popup ? gridFieldName ? this.resizedColumns.get(gridFieldName) : undefined : gridFieldWidth,
                    align: gridFieldAlign,
                    editor: false,
                };
            })
            : undefined;
    }
    closeModal(record) {
        if (record) {
            const { onSelect, modal } = this.props;
            if (modal) {
                modal.close();
            }
            onSelect(record);
        }
    }
    /* istanbul ignore next */
    handleKeyDown(e) {
        if (e.keyCode === KeyCode.ENTER) {
            this.handleSelect();
        }
    }
    /**
     * 单选 onRow 处理
     * @param props
     */
    handleRow(props) {
        const { tableProps } = this.props;
        if (tableProps) {
            const { onRow } = tableProps;
            if (onRow) {
                return {
                    onDoubleClick: this.handleSelect,
                    ...onRow(props),
                };
            }
        }
        return {
            onDoubleClick: this.handleSelect,
        };
    }
    handleSingleRow(props) {
        const { tableProps } = this.props;
        if (tableProps) {
            const { onRow } = tableProps;
            if (onRow) {
                return {
                    onClick: this.handleSelect,
                    ...onRow(props),
                };
            }
        }
        return {
            onClick: this.handleSelect,
        };
    }
    handleColumnResize(props) {
        const { width, column } = props;
        this.resizedColumns.set(getColumnKey(column), width);
    }
    renderTable() {
        const { dataSet, config: { queryBar, height, treeFlag, queryColumns, tableProps: configTableProps = {}, lovItems }, multiple, tableProps, viewMode, context, showSelectedInView, } = this.props;
        const { getConfig } = context;
        const columns = this.getColumns();
        const popup = viewMode === TriggerViewMode.popup;
        const modal = viewMode === TriggerViewMode.modal;
        const drawer = viewMode === TriggerViewMode.drawer;
        const percentItems = {};
        if (lovItems) {
            lovItems.filter(x => x.gridFieldType && x.gridFieldType.toLowerCase() === 'percent' && x.conditionField === 'Y').forEach(x => {
                percentItems[x.gridFieldName] = React.createElement(ObserverNumberField, { suffix: React.createElement("span", null, "%") });
            });
        }
        const lovTableProps = {
            autoFocus: true,
            mode: treeFlag === 'Y' ? TableMode.tree : TableMode.list,
            onKeyDown: this.handleKeyDown,
            dataSet,
            columns,
            queryFieldsLimit: queryColumns,
            queryBar: queryBar || getConfig('lovQueryBar') || getConfig('queryBar'),
            selectionMode: SelectionMode.none,
            ...configTableProps,
            ...tableProps,
            queryFields: {
                ...(tableProps && tableProps.queryFields),
                ...percentItems,
            },
            className: classNames(configTableProps && configTableProps.className, tableProps && tableProps.className),
            style: {
                ...(configTableProps && configTableProps.style),
                height,
                ...(tableProps && tableProps.style),
            },
            queryBarProps: {
                ...(tableProps && tableProps.queryBarProps),
                ...(configTableProps && configTableProps.queryBarProps),
                ...getConfig('lovQueryBarProps'),
            },
        };
        if (multiple) {
            if (popup || !tableProps || !tableProps.selectionMode) {
                if (lovTableProps.mode === TableMode.tree) {
                    lovTableProps.selectionMode = SelectionMode.treebox;
                }
                else {
                    lovTableProps.selectionMode = SelectionMode.rowbox;
                }
            }
            if (lovTableProps.selectionMode !== SelectionMode.rowbox && lovTableProps.selectionMode !== SelectionMode.treebox) {
                lovTableProps.highLightRow = false;
                lovTableProps.selectedHighLightRow = true;
            }
        }
        else if (popup) {
            lovTableProps.onRow = this.handleSingleRow;
        }
        else if (lovTableProps.selectionMode !== SelectionMode.rowbox) {
            lovTableProps.onRow = this.handleRow;
        }
        else {
            lovTableProps.highLightRow = false;
            lovTableProps.selectedHighLightRow = true;
        }
        if (popup) {
            if (lovTableProps.showSelectionCachedButton === undefined) {
                lovTableProps.showSelectionCachedButton = false;
                lovTableProps.showCachedSelection = true;
            }
            lovTableProps.autoFocus = false;
            lovTableProps.autoWidth = 'autoWidth' in lovTableProps ? lovTableProps.autoWidth : true;
            lovTableProps.onColumnResize = this.handleColumnResize;
        }
        const isProfessionalBar = lovTableProps.queryBar === TableQueryBarType.professionalBar;
        if (!popup && !lovTableProps.queryBar && isProfessionalBar) {
            lovTableProps.queryBar = (props) => React.createElement(TableProfessionalBar, Object.assign({}, props));
        }
        if ((modal || drawer) && showSelectedInView) {
            lovTableProps.showSelectionTips = false;
        }
        this.selectionMode = lovTableProps.selectionMode;
        return (React.createElement(React.Fragment, null,
            React.createElement(Table, Object.assign({}, lovTableProps)),
            modal && this.renderSelectionList()));
    }
    renderSelectionList() {
        const { dataSet, valueField = '', textField = '', config: { treeFlag, tableProps: configTableProps }, tableProps, multiple, viewMode, showSelectedInView, getSelectionProps, context, } = this.props;
        if (!showSelectedInView || !multiple) {
            return null;
        }
        if (!this.selectionMode) {
            const selectionMode = tableProps && tableProps.selectionMode || configTableProps && configTableProps.selectionMode;
            if (!selectionMode) {
                this.selectionMode = treeFlag === 'Y' ? SelectionMode.treebox : SelectionMode.rowbox;
            }
            else {
                this.selectionMode = selectionMode;
            }
        }
        const selectionsPosition = viewMode === TriggerViewMode.drawer ?
            SelectionsPosition.side :
            (viewMode === TriggerViewMode.modal ? SelectionsPosition.below : undefined);
        return (React.createElement(SelectionList, { dataSet: dataSet, treeFlag: treeFlag, valueField: valueField, textField: textField, selectionsPosition: selectionsPosition, selectionProps: getSelectionProps && getSelectionProps(), context: context }));
    }
    render() {
        const { modal, viewRenderer, dataSet, viewMode, config: lovConfig, textField, valueField, multiple, } = this.props;
        if (modal) {
            modal.handleOk(this.handleSelect);
        }
        return (React.createElement(React.Fragment, null,
            viewMode === TriggerViewMode.drawer && this.renderSelectionList(),
            React.createElement("div", null, viewRenderer
                ? toJS(viewRenderer({
                    dataSet,
                    lovConfig,
                    textField,
                    valueField,
                    multiple,
                    modal,
                }))
                : this.renderTable())));
    }
}
__decorate([
    action
], LovView.prototype, "componentWillMount", null);
__decorate([
    action
], LovView.prototype, "componentWillUnmount", null);
__decorate([
    autobind
], LovView.prototype, "handleKeyDown", null);
__decorate([
    autobind
], LovView.prototype, "handleRow", null);
__decorate([
    autobind
], LovView.prototype, "handleSingleRow", null);
__decorate([
    autobind
], LovView.prototype, "handleColumnResize", null);
